module.exports = __webpack_public_path__ + "img/item_18.8df757ce.png";